(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-grid"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.thumbnail-wrapper').forEach(el => {
  el.addEventListener('click', function(){
    const url = this.dataset.video;
    if (!url) return;

    // Open video in a new tab or replace with popup logic
    window.open(url, "_blank");
  });
});

  } catch(e) { console.error(e); }
})();
})();
